var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskAltOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 7.77L15.885 24.9L9.525 18.54L11.64 16.425L15.885 20.67L30.885 5.67L33 7.77ZM29.685 15.33C29.88 16.185 30 17.085 30 18C30 24.63 24.63 30 18 30C11.37 30 6 24.63 6 18C6 11.37 11.37 6 18 6C20.37 6 22.56 6.69 24.42 7.875L26.58 5.715C24.15 4.005 21.195 3 18 3C9.72 3 3 9.72 3 18C3 26.28 9.72 33 18 33C26.28 33 33 26.28 33 18C33 16.215 32.67 14.505 32.1 12.915L29.685 15.33Z",
    fill: "#06BF97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskAltOutlined);
export default __webpack_public_path__ + "static/media/task-alt-outlined.28ecc121680173e3e7ffdac39ffe66c7.svg";
export { ForwardRef as ReactComponent };